import { DestroyRef, Injectable, Type, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalLinkService } from '@core/feature';

import { DesignRequestModalComponent, RoofRequestModalComponent, SmarthomeRequestModalComponent } from '@callback/ui';
import { SdModalService } from '@sdvor/shared/ui/v2';
import { SdModalOptionsWithBreakpoints } from '@shared/v2';

// TODO: Используется для обратной совместимости, после того как задача SPA-1942 выедет в прод, проверить что все ссылки поменяли и выпилить
enum CallbackCmsComponents {
  RosaCMSDesignRequestComponent = 'RosaCMSDesignRequestComponent',
  RosaCMSRoofMeasurementRequestComponent = 'RosaCMSRoofMeasurementRequestComponent',
  RosaCMSSmartHomeRequestComponent = 'RosaCMSSmartHomeRequestComponent',
}

@Injectable({ providedIn: 'root' })
export class CallbackModalLinkListenerService {
  private readonly modalLinkService = inject(ModalLinkService);
  private readonly modalService = inject(SdModalService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly callbackModalOptions: SdModalOptionsWithBreakpoints = {
    modalType: { xxs: 'compact', md: 'standard' },
    maxWidth: { md: '464px' },
  };
  private readonly callbackModals: Record<string, Type<any>> = {
    [CallbackCmsComponents.RosaCMSDesignRequestComponent]: DesignRequestModalComponent,
    [CallbackCmsComponents.RosaCMSRoofMeasurementRequestComponent]: RoofRequestModalComponent,
    [CallbackCmsComponents.RosaCMSSmartHomeRequestComponent]: SmarthomeRequestModalComponent,
    DesignRequestModalComponent: DesignRequestModalComponent,
    RoofRequestModalComponent: RoofRequestModalComponent,
    SmarthomeRequestModalComponent: SmarthomeRequestModalComponent,
  };

  constructor() {
    this.modalLinkService.openedModalName.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((modalName) => {
      const modalComponent = this.callbackModals[modalName];
      if (!modalComponent) {
        return;
      }

      this.modalService.open(modalComponent, this.callbackModalOptions);
    });
  }
}
